import React from 'react';
import { Button, Alert, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup } from 'reactstrap';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import UserChips from '../UserChips';
import { Flag } from 'flagger/react';
import { Autocomplete, TextField } from '@mui/material';
import { getAll as getAllUsers} from '../../services/userService'

class NewPrinterDestinationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      lang: '',
      destinations: [],
      clients: [],
      printers: [],
      folders: [],
      printerModalVisible: false,
      printersarray: [],
      usersarray: [],
      usernames: []
    }

    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.getX3ArchiveDestinations = this.getX3ArchiveDestinations.bind(this);
    this.getX3PrinterClients = this.getX3PrinterClients.bind(this);
    this.getX3Printers = this.getX3Printers.bind(this);
    this.getX3Folders = this.getX3Folders.bind(this);
    this.togglePrintersModal = this.togglePrintersModal.bind(this);
    this.validateDestination = this.validateDestination.bind(this);
    this.handlePrintDropdownChange = this.handlePrintDropdownChange.bind(this);
    this.remove = this.remove.bind(this);
  }

  validateDestination() {
    var valid = true;

    if (!this.state.groupName)
      valid = false;
    if (!this.state.selectedFolder)
      valid = false;
    if (!this.state.selectedDestination)
      valid = false;
    if (!this.state.printersarray && this.state.printersarray.length > 0)
      valid = false;
    else if (this.state.printersarray[0].print_client_name === "") {
      valid = false;
    }

    if (!valid) {
      this.props.alert.error("Unable to save destination please make sure enteries are valid"); //Bug 13321: Inscribe: Spelling mistake in Print Destination message
    }
    else {
      //check if the folder and destination combination already exist.
      this.getDestination(this.state.selectedFolder, this.state.selectedDestination, this.state.usersarray)
        .then((result) => {
          this.props.alert.error("A destination for folder " + this.state.selectedFolder + " and destination " + this.state.selectedDestination + " already exist.");
        })
        .catch((error) => {
          this.props.newDestination(this.state.groupName, this.state.selectedFolder, this.state.selectedDestination, this.state.printersarray, this.state.usersarray)
          this.setState({ printersarray: [] });
        });
    }
  }

  getDestination(folder, destination, usernames) {
    return new Promise((resolve, reject) => {
      let user_query = '';

      for (let i in usernames)
        user_query += '&username[]=' + usernames[i]

      fetch(window.location.protocol + '//' + window.location.host + "/api/printing/destination?folder=" + folder + "&destination=" + destination + user_query)
        .then(res => res.json())
        .then(result => {
          if (result.destination) {
            resolve();
          }
          else {
            reject();
          }
        })
    });
  }

  getUsers = async () => {
    const result = await getAllUsers({ isActive : true});
    let usernames = [];
    for (const u of result.data) {
      usernames.push(u.username);
    }
    this.setState({usernames: usernames});
  }

  componentDidMount() {
    this.formIsLoading();
    this.getX3Folders();
    this.getX3PrinterClients();
    this.getUsers();

    var newArray = this.state.printersarray.slice();
    var printerObj = {
      'id': 0,
      'print_name': '',
      'print_client_name': '',
      'print_count': '0',
      'watermark': ''
    }
    newArray.push(printerObj);
    this.setState({ printersarray: newArray })
  }

  componentDidUpdate(prevProps, prevState) {

    //prevProps check visible here and reload.
    if (prevProps.toggle != this.props.toggle) {
      this.formIsLoading();
      this.getX3PrinterClients();
    }

    if (prevState.selectedFolder != this.state.selectedFolder) {
      this.formIsLoading();
      this.getX3ArchiveDestinations();
    }

  }

  formIsLoading() {
    this.setState({ isLoading: true });
  }

  handleDropdownChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handlePrintDropdownChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const id = target.id;

    var found = this.state.printersarray.find(element => {
      return element.id == id;
    });

    if (!this.state.printersarray.includes(found)) {
      var printerObj = {
        'id': this.state.printersarray.length,
        'print_name': '',
        'print_client_name': '',
        'print_count': '0',
        'watermark': ''
      }

      this.setState(prevState => ({
        printersarray: prevState.printersarray.concat(printerObj)
      }))
    }
    else {
      found[name] = value;

      var newArray = this.state.printersarray;
      newArray.splice(id, 1, found);

      this.setState({
        printersarray: newArray
      })
    }

    // var newArray = this.state.printersarray.slice();
    // var printerObj = newArray.splice(id, 1)[0];    
    // console.log(printerObj);
    // printerObj[name] = value;
    // newArray.splice(id, 1, printerObj);
    // console.log(newArray);

    // this.setState({
    //     printersarray: newArray
    // });

    // if(name === 'print_client_name')
    //   this.getX3Printers(value);
  }

  getX3Folders = async () => {
    try {
      const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
      });

      const payload = await r.json();

      if (!r.ok) {
        console.error("get_X3_folders failed", payload);
        this.setState({ isLoading: false });
        return;
      }

      this.setState({
        folders: payload?.folders ?? [],
        isLoading: false
      });
    } catch (err) {
      console.error("get_X3_folders error", err);
      this.setState({ isLoading: false });
    }
  };

 getX3ArchiveDestinations = async () => {
  try {
    const res = await fetch(
      `${window.location.protocol}//${window.location.host}/api/sageX3/get_X3_destinations?folder=${this.state.selectedFolder}`
    );
    const result = await res.json();
    
    this.setState({
      destinations: result.destinations,
      isLoading: false,
    });
  } catch (error) {
    console.error("Failed to fetch destinations:", error);
    this.setState({ isLoading: false });
  }
}

  getX3PrinterClients() {
    fetch(window.location.protocol + '//' + window.location.host + "/api/printing/x3printerclients")
      .then(res => res.json())
      .then(result => {
        this.setState({
          clients: result.clients,
          isLoading: false,
          noConnectedClients: result.clients.length > 0 ? false : true
        })
      })
  }

  getX3Printers(selectedPrintClient) {
    fetch(window.location.protocol + '//' + window.location.host + "/api/printing/x3printers?client=" + selectedPrintClient)
      .then(res => res.json())
      .then(result => {
        this.setState({
          printers: result.printers,
          isLoading: false
        })
      })
  }

  togglePrintersModal() {
    var newArray = this.state.printersarray.slice();
    var printerObj = {
      'id': this.state.printersarray.length,
      'print_name': '',
      'print_client_name': '',
      'print_count': '0',
      'watermark': ''
    }
    newArray.push(printerObj);
    this.setState({ printersarray: newArray })
  }

  remove(id) {
    // create new array and re-assign ids on remove
    var newArray = [];
    var newid = 0;

    this.state.printersarray.forEach((printer, i) => {
      if (i != id) {
        var printerObj = {
          'id': newid,
          'print_name': printer.print_name,
          'print_client_name': printer.print_client_name,
          'watermark': printer.watermark,
          'print_count': printer.print_count
        }
        newArray.push(printerObj);
        newid++;
      }
    });

    this.setState({ printersarray: newArray })
  }

  addUser = (name) => {
    let users = this.state.usersarray;

    users.push(name);

    this.setState({
      usersarray: users
    })
  }

  removeUser = (name) => {
    let users = this.state.usersarray.filter(u => u !== name)
    this.setState({
      usersarray: users
    })
  }

  render() {
    const {
      isLoading,
      noConnectedClients,
      clients: clientsData = [],
      destinations: destData = [],
      folders: folderData = [],
      printersarray = [],
      usernames,
      usersarray,
    } = this.state;
  
    const { localisation } = this.props.userReducer;
  
    /* ---------- option helpers ---------- */
  
    const folderOptions = folderData.map(f => (
      <option key={f.folder} value={f.DOSSIER}>
        {f.DOSSIER}
      </option>
    ));

    const destinationOptions = destData.map(d => (
      <option key={d.destination} value={d.destination}>
        {d.destination}
      </option>
    ));

    // shared <option>s for every client <select>
    const clientOptions = [
      <option key="_blank" value="">
        {localisation['default_select_text']
          ? localisation['default_select_text'].element_lang
          : 'Select...'}
      </option>,
      ...clientsData.flatMap(c => {
        const name = Object.keys(c)[0];
        return (
          <option key={name} value={name}>
            {name}
          </option>
        );
      }),
    ];
  
    /* ---------- printer rows ---------- */
  
    const printersarraylist = printersarray.map((printer, i) => {
      // raw lookup object (never rendered)
      const clientMatch = printer.print_client_name
        ? clientsData.find(c => c[printer.print_client_name])
        : null;
  
      // turn printer names into <option> nodes
      const printerOptions = [
        <option key="_blank" value="">
          {localisation['default_select_text']
            ? localisation['default_select_text'].element_lang
            : 'Select...'}
        </option>,
        ...(clientMatch
          ? (clientMatch[printer.print_client_name][0].printers || []).map(p => (
              <option key={p} value={p}>
                {p}
              </option>
            ))
          : []),
      ];
  
      return (
        <Row key={i} form>
          {/* ---- client ---- */}
          <Col md={2}>
            <FormGroup>
              <Label
                htmlFor={`print_client_name_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['client_name_text']
                  ? localisation['client_name_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="select"
                name="print_client_name"
                id={i}
                value={printer.print_client_name}
                onChange={this.handlePrintDropdownChange}
              >
                {clientOptions}
              </Input>
            </FormGroup>
          </Col>
  
          {/* ---- printer ---- */}
          <Col md={4}>
            <FormGroup>
              <Label
                htmlFor={`print_name_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['printer_name_text']
                  ? localisation['printer_name_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="select"
                name="print_name"
                id={i}
                value={printer.print_name}
                onChange={this.handlePrintDropdownChange}
              >
                {printerOptions}
              </Input>
            </FormGroup>
          </Col>
  
          {/* ---- watermark ---- */}
          <Col md={2}>
            <FormGroup>
              <Label
                htmlFor={`watermark_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['watermark_text']
                  ? localisation['watermark_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="text"
                name="watermark"
                id={i}
                value={printer.watermark}
                onChange={this.handlePrintDropdownChange}
              />
            </FormGroup>
          </Col>
  
          {/* ---- copies ---- */}
          <Col md={2}>
            <FormGroup>
              <Label
                htmlFor={`print_count_${i}`}
                className="s-field-title s-anchored"
              >
                {localisation['copies_text']
                  ? localisation['copies_text'].element_lang
                  : ''}
              </Label>
              <Input
                type="text"
                name="print_count"
                id={i}
                value={printer.print_count}
                onChange={this.handlePrintDropdownChange}
              />
            </FormGroup>
          </Col>
  
          {/* ---- remove ---- */}
          <Col md={2}>
            <FormGroup>
              <Button
                className="navbtn s-fonticon-btn"
                outline
                color="danger"
                style={{ marginTop: '25px', padding: '3px 7px' }}
                onClick={() => this.remove(i)}
              >
                
              </Button>
            </FormGroup>
          </Col>
        </Row>
      );
    });
  
    /* ---------- misc UI ---------- */
  
    const loading = isLoading ? (
      <Progress animated color="info" value={100} />
    ) : null;
  
    const noConnectedClientsAlertNode = noConnectedClients ? (
      <Alert color="danger">
        {localisation['no_connected_clients_text']
          ? localisation['no_connected_clients_text'].element_lang
          : ''}
      </Alert>
    ) : null;
  
    /* ---------- full return ---------- */
    return (
      <Modal
        isOpen={this.props.visible}
        toggle={this.props.toggle}
        className="modal-dialog"
      >
        <ModalHeader toggle={this.props.toggle}>
          {localisation['new_print_destinations_header']
            ? localisation['new_print_destinations_header'].element_lang
            : ''}
        </ModalHeader>
  
        <ModalBody>
          {/* ---- top section ---- */}
          <Row form>
            <Col lg={12}>
              <FormGroup>
                <Label
                  htmlFor="groupName"
                  className="s-field-title s-anchored"
                >
                  {localisation['table_header_name']
                    ? localisation['table_header_name'].element_lang
                    : ''}
                </Label>
                <Input
                  type="text"
                  name="groupName"
                  id="groupName"
                  onChange={this.handleDropdownChange}
                />
              </FormGroup>
            </Col>
  
            <Col lg={12}>
              <FormGroup>
                <Label
                  htmlFor="selectedFolder"
                  className="s-field-title s-anchored"
                >
                  {localisation['table_header_folder']
                    ? localisation['table_header_folder'].element_lang
                    : ''}
                </Label>
                <Input
                  type="select"
                  name="selectedFolder"
                  id="selectedFolder"
                  onChange={this.handleDropdownChange}
                >
                  {folderOptions}
                </Input>
              </FormGroup>
            </Col>
  
            <Col lg={12}>
              <FormGroup>
                <Label
                  htmlFor="selectedDestination"
                  className="s-field-title s-anchored"
                >
                  {localisation['table_header_destination']
                    ? localisation['table_header_destination'].element_lang
                    : ''}
                </Label>
                <Input
                  type="select"
                  name="selectedDestination"
                  id="selectedDestination"
                  onChange={this.handleDropdownChange}
                >
                  {destinationOptions}
                </Input>
              </FormGroup>
            </Col>
          </Row>
  
          {/* ---- users ---- */}
          <Flag flag="PrintByUser" entity={{ id: 1 }} case="on">
            <header className="s-h2-head-search">
              <div className="s-h2-title" title="Printers">
                {localisation['users_text']
                  ? localisation['users_text'].element_lang
                  : 'Users'}
              </div>
            </header>
            <UserChips
              usernames={usernames}
              users={usersarray}
              handleDelete={this.removeUser}
              addUser={this.addUser}
            />
          </Flag>
  
          {/* ---- printers ---- */}
          <header className="s-h2-head-search">
            <div className="s-h2-title" title="Printers">
              {localisation['printers_text']
                ? localisation['printers_text'].element_lang
                : ''}
            </div>
          </header>
  
          {noConnectedClientsAlertNode}
          {printersarraylist}
          {loading}
        </ModalBody>
  
        <ModalFooter>
          <Button
            color="success"
            style={{ position: 'absolute', left: '20px' }}
            onClick={this.togglePrintersModal}
          >
            {localisation['add_printer_button']
              ? localisation['add_printer_button'].element_lang
              : ''}
          </Button>
          <Button color="primary" onClick={this.validateDestination}>
            {localisation['save_button']
              ? localisation['save_button'].element_lang
              : ''}
          </Button>
          <Button color="danger" onClick={this.props.toggle}>
            {localisation['cancel_button']
              ? localisation['cancel_button'].element_lang
              : ''}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(state => state)(withAlert()(NewPrinterDestinationModal));